/** Единый источник FAQ для страницы /faq и JSON-LD FAQPage */
export const faqIntro =
  'Антология — поставщик лицензий и подписок на ПО для компаний в России: покупка, учёт и продление в одном сервисе, оплата в рублях. Подбираем продукт, общаемся с вендорами, оформляем поставку на ваш аккаунт. Внедрение ИИ — отдельный контур на /services.';

export const faqItems = [
  {
    question: 'Чем Антология отличается от обычной витрины лицензий?',
    answer:
      'Мы поставщик лицензий и подписок для юрлиц, а не витрина с корзиной «как у ритейла». Фокус — покупка, учёт и продление в одном сервисе: сами в кабинете или через менеджера. Оплата в рублях, закрывающие документы, поставка на аккаунт компании.',
  },
  {
    question: 'Можно ли вести учёт лицензий самим или только через менеджера?',
    answer:
      'Оба варианта. Учёт и продление можно вести сами в одном окне сервиса или делегировать менеджеру в чате: КП, сравнение, оформление и продление. Корзину на сайте при желании тоже можно использовать — это не единственный сценарий.',
  },
  {
    question: 'Вы работаете с подписками и продлением, а не только с разовой покупкой?',
    answer:
      'Да. Помогаем купить и продлить лицензии и подписки на ПО, включая AI-сервисы. Напоминания и сопровождение продления — часть оффера поставщика; детали зависят от продукта и договора.',
  },
  {
    question: 'Какие направления IT и AI решений вы предлагаете?',
    answer:
      'Каталог решений по задачам: лицензии и подписки на российский и зарубежный софт, AI-сервисы (облако и on-premise). Внедрение и интеграция ИИ — на странице /services, это отдельный контур. Актуальный список — в «Каталоге решений».',
  },
  {
    question: 'Поставляете ли вы только российское ПО или зарубежное тоже?',
    answer:
      'И то, и другое. Работаем с отечественными и международными вендорами в зависимости от задачи, требований ИБ и ваших правил закупок. На консультации подскажем, что разумнее в вашем случае: российский стек, зарубежный или смешанный.',
  },
  {
    question: 'Какие AI решения вы поставляете?',
    answer:
      'Лицензии и сопровождение корпоративного AI: ассистенты, агенты, платформы агентов, речевая аналитика, омниканальные коммуникации, корпоративные базы знаний, в том числе сценарии с RAG. Есть облачные и on-premise варианты. Конкретный набор зависит от вендора: смотрите каталог и карточки партнёров, например Just AI и UIS.',
  },
  {
    question: 'Как происходит поставка зарубежного ПО в России?',
    answer:
      'Сначала созваниваемся и разбираем задачу: что нужно, сколько лицензий, какие требования по безопасности и закупкам. Дальше подбираем продукт и согласуем условия с вендором или официальным каналом поставки. Заключаем договор: работаем с юрлицами и ИП, оплата в рублях по счёту ООО «Успенский Технологии» (бренд Антология). После оплаты активируем лицензии на аккаунте вашей компании и передаём документы в бухгалтерию. Внедрение, интеграция и SLA по запросу. Сроки зависят от продукта, озвучиваем их до подписания договора.',
  },
  {
    question: 'Чем отличается закупка российского ПО от зарубежного через Антологию?',
    answer:
      'С российским ПО чаще приходят за импортозамещением или требованиями к отечественному софту в реестре. С зарубежным, когда нужен привычный глобальный продукт или специфика вендора. В обоих случаях мы помогаем с подбором, лицензиями и документами, для импортного ещё с переговорами, продлением на вашем аккаунте и поставкой. Оплата в обоих вариантах в рублях, B2B, со счёта вашей организации. Службу безопасности и закупок мы не подменяем: берём на себя легальную поставку лицензий и техсопровождение.',
  },
  {
    question: 'Можно ли закупить зарубежные AI лицензии через вас?',
    answer:
      'Да, если продукт есть в нашем портфеле и его можно поставить в вашей конфигурации, то дадим выгодную цену. Все остальные сервисы приобрести через нас можно, лицензия или продление будет на ваш аккаунт. Облако или on-premise, регион, объём: всё обсуждаем на консультации. Для команд с Gen AI-инфраструктурой смотрите оффер https://antologia.tech/gen-ai-creative. Напишите на hi@antologia.tech или оставьте заявку на сайте.',
  },
  {
    question: 'Закупка лицензий на ПО и AI для компании: с чего начать?',
    answer:
      'Опишите задачу: какой процесс закрываете, сколько пользователей, нужен ли on-premise. Запишитесь на консультацию через Calendly или форму на сайте. После разбора предложим один-два варианта: российский, зарубежный или комбинированный. КП с примерными сроками и составом работ.',
  },
  {
    question: 'Как оплачивать? Работаете ли вы с физическими лицами?',
    answer:
      'Только с юридическими лицами и ИП. Оплата безналичным расчетом в рублях со счёта вашей организации, закрывающие документы для бухгалтерии. Рассрочку до трёх месяцев даём по согласованию.',
  },
  {
    question: 'Можно ли оплатить зарубежную лицензию в рублях, не переводя деньги за рубеж самим?',
    answer:
      'Часто да. Вы платите нашему юрлицу в рублях, а оплату лицензии и общение с вендором ведем мы. Точная схема зависит от продукта, уточняйте на консультации. Сценарий для креативных и маркетинговых команд: https://antologia.tech/gen-ai-creative.',
  },
  {
    question: 'Сколько времени занимает поставка и внедрение?',
    answer:
      'Жёстких сроков для всех продуктов нет. Консультация и подбор от одного дня. Поставка лицензий на тиражируемое ПО от одного рабочего дня. Настройка AI решений обычно от трёх до семи рабочих дней. Обучение пользователей от 3 рабочих дней. Точный график в коммерческом предложении после разбора задачи.',
  },
  {
    question: 'Что входит в поддержку по SLA?',
    answer:
      'Зависит от продукта и договора. Обычно это приём заявок, реакция и восстановление по согласованным уровням, обновления в рамках лицензии, консультации по работе с системой. Время реакции, каналы и часы поддержки фиксируем в договоре до старта. Единый сервис-деск на все решения пока в разработке, актуальный статус уточняйте у менеджера.',
  },
  {
    question: 'Какие услуги интеграции и поддержки вы предоставляете?',
    answer:
      'Подключаем AI и IT решения к вашей инфраструктуре: CRM, ERP, ассистент, агент и тд. Настраиваем под процессы, при необходимости дорабатываем, обучаем сотрудников, сопровождаем после запуска. Объём работ согласуем при подборе решения. Внедрение без доработок включено в стоимость лицензии. Написание кастомного функционала от 300 000 рублей. Техническая поддержка AI-сервисов (ЦБР) - от 99 000 рублей в месяц, подробнее на странице /cbr. В поддержку входят услуги связанные с llm и harness. Уточняйте подробности у менеджера.',
  },
  {
    question: 'Кто отвечает за обучение сотрудников?',
    answer:
      'Обычно это часть внедрения, можно заказать отдельно. Формат: онлайн или очно, для админов и пользователей. Программу подстраиваем под ваши роли и регламенты.',
  },
  {
    question: 'Как обеспечивается безопасность данных?',
    answer:
      'Сначала выясняем, где данные могут храниться: облако в РФ, on-premise, частное облако. Подбираем продукт под ваши политики ИБ. Детали по технике и организации в документации вендора. Если нужно, подключаем вашу ИБ на этапе согласования архитектуры.',
  },
  {
    question: 'Можно ли протестировать решение перед покупкой?',
    answer:
      'У многих вендоров есть пилот, демо или trial, не у всех и не на любой срок. На консультации скажем, есть ли тест для выбранного продукта.',
  },
  {
    question: 'Можно ли масштабировать решение?',
    answer:
      'Да. Лицензии и тарифы обычно растут вместе с числом пользователей, объёмом или модулями. Когда нагрузка увеличится, поможем пересчитать лицензии и при необходимости доработать интеграцию.',
  },
  {
    question: 'Работаете ли вы с крупными компаниями?',
    answer:
      'Да. С 2017 года сделали больше сотни проектов для среднего и крупного бизнеса в России: поставка лицензий, внедрение, SLA.',
  },
  {
    question: 'Какие CRM и ERP системы вы интегрируете?',
    answer:
      'Зависит от продукта и вашего ландшафта. На этапе ТЗ фиксируем системы: 1С, CRM, API, шины данных и т.д. Частый сценарий: связать AI ассистентов, аналитику и коммуникации с учётными и клиентскими системами.',
  },
  {
    question: 'Как связаться с Антологией?',
    answer:
      'Почта: hi@antologia.tech. Встречу можно записать через Calendly (ссылка на сайте). Есть форма «Обсудить задачу». Юрлицо: ООО «Успенский Технологии». Работаем с юрлицами и ИП.',
  },
];
